import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';

const SEARCH_BY_NET_ID = gql`
  query ($netId: String!) {
    rolePlay(netId: $netId) {
      access_token
    }
  }
`;

export const useRolePlay = async (
  client: ApolloClient<NormalizedCacheObject>,
  netId: string,
): Promise<any> => {
  const { data } = await client.query({
    query: SEARCH_BY_NET_ID,
    variables: { netId },
    fetchPolicy: 'network-only',
  });

  const accessTK = data?.rolePlay?.access_token ?? '';

  return { accessTK };
};
